/**
 * Token Refresh Lock Service
 * 
 * Provides a shared lock mechanism for token refreshing to prevent
 * multiple simultaneous refresh requests from different parts of the app
 * (e.g., proactive token refresh service vs reactive Axios interceptor).
 */

let refreshPromise = null;
let cookieRefreshPromise = null;

/**
 * Check if a token refresh is currently in progress
 * @returns {boolean} True if refreshing
 */
export const isRefreshing = () => refreshPromise !== null;

/**
 * Check if a cookie refresh is currently in progress
 * @returns {boolean} True if refreshing
 */
export const isCookieRefreshing = () => cookieRefreshPromise !== null;

/**
 * Execute or join a token refresh operation
 * @param {Function} refreshFn - The function that performs the actual refresh and returns a Promise
 * @returns {Promise} The promise resolving to the refresh result
 */
export const executeRefresh = (refreshFn) => {
    if (refreshPromise) {
        return refreshPromise;
    }

    refreshPromise = refreshFn().finally(() => {
        refreshPromise = null;
    });

    return refreshPromise;
};

/**
 * Execute or join a cookie refresh operation 
 * @param {Function} refreshFn - The function that performs the actual refresh and returns a Promise
 * @returns {Promise} The promise resolving to the refresh result
 */
export const executeCookieRefresh = (refreshFn) => {
    if (cookieRefreshPromise) {
        return cookieRefreshPromise;
    }

    cookieRefreshPromise = refreshFn().finally(() => {
        cookieRefreshPromise = null;
    });

    return cookieRefreshPromise;
};

/**
 * Clear any active refresh locks (useful for cleanup on logout)
 */
export const clearRefreshLocks = () => {
    refreshPromise = null;
    cookieRefreshPromise = null;
};
